import React from 'react';
import { MediaQueryIcon } from 'admin/components/common/MediaQueryIcon';
import type { StoryDefaultPlatform, StoryMediaQuery } from 'types/story';
import { getDesignPresetPlatformName } from './design-preset-display';
import css from './DesignPresetsEditor.scss';

/** A cell editor's header: the property, and the platform it edits drawn as in its column */
export default function DesignPresetEditorHeader({
	label,
	platform,
	mediaQuery,
}: {
	label: string;
	platform: 'base' | StoryDefaultPlatform;
	mediaQuery: StoryMediaQuery;
}) {
	const key = platform === 'base' ? mediaQuery.defaultPlatform : platform;
	const name = getDesignPresetPlatformName(key, mediaQuery.config[key]?.uiName);
	return (
		<header className={css.groupEditorHeader}>
			<strong>{label}</strong>
			<span className={css.groupEditorPlatform}>
				<MediaQueryIcon platform={key} defaultPlatform={mediaQuery.defaultPlatform} width={16} height={16} />
				{platform === 'base' ? `${name} · Base` : name}
			</span>
		</header>
	);
}
